import React, { useState, useEffect, useRef, useCallback } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';  // Import Bootstrap Icons
import Home from './pages/home';
import ItWork from './pages/itwork';
import Footer from './pages/footer';
import Company from './pages/company';
import png2 from "./assets/PNG_2.png";
import logo from "./assets/logo2.webp";
import sound from "./assets/Cinnamoroll.mp3";

function App() {
  const [containStyle, setContainStyle] = useState("content");
  const [isLoading, setIsLoading] = useState(true);
  const [isMuted, setIsMuted] = useState(true); // Start muted
  const [audioReady, setAudioReady] = useState(false); // Track if audio is ready to play

  const audioRef = useRef(new Audio(sound));

  // Function to toggle mute and unmute the audio
  const toggleMute = () => {
    setIsMuted((prevState) => {
      const newMutedState = !prevState;
      if (newMutedState) {
        audioRef.current.pause(); // Pause if muted
      } else {
        audioRef.current.play(); // Play if unmuted
      }
      return newMutedState;
    });
  };

  // Handle audio playback after first click
  const handleAudioPlay = useCallback(() => {
    if (!audioReady) {
      audioRef.current.play().catch((err) => {
        console.error("Audio play blocked: ", err);
      });
      setAudioReady(true); // Set audio ready flag after first play
    }
  }, [audioReady]);

  // Use Effect to handle the loading page and simulate audio play on first user click
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => {
      clearTimeout(timer); // Cleanup timer
    };
  }, []);

  // Event listener for user interaction to start audio playback
  useEffect(() => {
    if (!audioReady) {
      const startAudioOnClick = () => {
        handleAudioPlay();
        setIsMuted(prevState => !prevState);
        document.removeEventListener('click', startAudioOnClick); // Remove listener after first interaction
      };

      document.addEventListener('click', startAudioOnClick);

      return () => {
        document.removeEventListener('click', startAudioOnClick);
      };
    }
  }, [audioReady, handleAudioPlay]); // Include handleAudioPlay in dependency array

  const handleContainChange = (status) => {
    setContainStyle(status ? "content" : "none");
    console.log(containStyle);
  };

  return (
    <div className="App" style={{ contain: containStyle }}>
      {isLoading && (
        <div className="loading-page" style={{ backgroundColor: "#F9DBE7" }}>
          <img src={logo} alt="Logo" className="loader-logo" />
        </div>
      )}
      <div className="top-right-logo" onClick={toggleMute} style={isLoading ? { display: "none" } : {}}>
        <i className={`bi ${isMuted ? 'bi-volume-mute' : 'bi-volume-up'} interactive-logo`}></i>
      </div>

      <img src={png2} alt="Riding Logo" className="riding-image" />
      <Home />
      <ItWork />
      <Company onContainChange={handleContainChange} />
      <Footer />
    </div>
  );
}

export default App;
